import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';
import { pxToRem } from '../../styles/utils';
import { ImageData } from '../../utils/contentful';

import { Box } from '../Box';
import { GlImage } from '../Image';

import greenBullet from '@/images/green-bullet.svg';

const ONE_COLUMN_WIDTH = 100 / 12;

export const BlogImagePositioner = styled('div')`
  margin: ${({ theme }) => theme.spacing.ml} -${ONE_COLUMN_WIDTH}%;
`;

export const BlogImage = styled(GlImage)`
  border-radius: ${({ theme }) => theme.borderRadius.blockquote_0};
  display: block;
  margin: ${({ theme }) => theme.spacing.ml} auto;
  max-width: calc(
    ${({ width = 1, height = 1 }: ImageData) => {
      const aspectRatio = width / height || 1;
      return `630px * ${aspectRatio}`;
    }}
  );
  max-height: 640px;

  ${mediaQueries.tablet} {
    margin: ${pxToRem(45)} auto;
    border-radius: ${({ theme }) => theme.borderRadius.blockquote_tablet};
  }
`;

export const UnorderedList = styled('ul')`
  padding-left: ${({ theme }) => theme.spacing.ml};
  list-style-image: url(${greenBullet.src});
  list-style-position: outside;
`;

export const Image7030TextContainer = styled(Box)<{ imageFirst: boolean }>`
  margin: ${({ theme }) => `${theme.spacing.ml} -${ONE_COLUMN_WIDTH}%`};

  ${mediaQueries.tablet} {
    margin: ${({ theme, imageFirst }) =>
      imageFirst
        ? `${theme.spacing.l} 0 ${theme.spacing.l} -${ONE_COLUMN_WIDTH}%`
        : `${theme.spacing.l} -${ONE_COLUMN_WIDTH}% ${theme.spacing.l} 0`};
  }
`;
